import Link from "next/link";

import { Logo, Button } from "@newsela/angelou";

import withTrackEvent from "@/eventStream/withTrackEvent";
import CloseIcon from "@/icons/CloseIcon";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import {
  logoItemCss,
  viewModeMessageStyle,
  assignmentViewButtonStyle,
  iconCss,
  closeButton,
  containerStyle,
} from "./AssignmentPreviewBanner.style";

const AssignmentPreviewBanner = (props) => {
  const CtaButtonText = "Close";
  const ButtonWithTrackEvent = withTrackEvent(Button);

  return (
    <ul css={[containerStyle, props.__css]}>
      <li css={logoItemCss}>
        <Link href={MONOLITH_ORIGIN} passHref legacyBehavior>
          <a aria-label="Newsela Home">
            <span>
              <Logo />
            </span>
          </a>
        </Link>
      </li>
      <li css={viewModeMessageStyle}>
        <span>You are viewing this content from an assignment</span>
      </li>
      <li css={closeButton}>
        <ButtonWithTrackEvent
          objectType="Content"
          actionPrefix="Cancel"
          actionName="Interactive-Video"
          legacyEventName="Interactive-Video-ViewMode"
          streamProperties={{ description: "Exit Preview (View Mode)." }}
          __cssFor={{ root: assignmentViewButtonStyle }}
          legacy_statusColor={Button.legacy_statusColor.black}
          labelPosition="before"
          onClick={() => window.close()}
          secondary
          trackView
        >
          <CloseIcon css={iconCss} />
          {CtaButtonText}
        </ButtonWithTrackEvent>
      </li>
    </ul>
  );
};

export default AssignmentPreviewBanner;
